import React from "react";

function NotFound() {
  return (
    <div style={{ textAlign: "center", padding: "80px" }}>
      <h1>404</h1>
      <h2>הדף לא נמצא</h2>
      <p>ייתכן שהקישור שגוי או שהעמוד הוסר.</p>
    </div>
  );
}

export default NotFound;